var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vanber"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v("平台岗位管理")]),_c('el-breadcrumb-item',[_vm._v("岗位发布")])],1),_c('v-recruiting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }